import random from 'toxilibs/random.js'
import Level from '../../core/level.js'

const level = new Level({
    name: 'positives_negatives_additions'
})


function commonSum (q, val1, val2) {
    let formula = (val1 < 0 ? '(' + val1 + ')' : val1) +
                  '+' +
                  (val2 < 0 ? '(' + val2 + ')' : val2)
    q.addMathFormula(formula)

    let result = val1 + val2
    q.answer = [
        result,
        q.evalAnswer(result)
    ]
}


//Pré-requis: somme avec des entiers positifs & negatifs
level.addQuestion({
    generator: function (q) {
        let positive = random.fairChoiceInt(10, 20, {name: 'positive'})
        let negative = -random.fairChoiceInt(1, 10, {name: 'negative'})

        commonSum(q, positive, negative)
    }
})


level.addQuestion({
    generator: function (q) {
        let positive = random.fairChoiceInt(0, 10, {name: 'positive'})
        let negative = -random.fairChoiceInt(10, 20, {name: 'negative'})

        commonSum(q, positive, negative)
    }
})


level.addQuestion({
    generator: function (q) {
        let val1 = -random.fairChoiceInt(0, 10, {name: 'val1'})
        let val2 = -random.fairChoiceInt(10, 20, {name: 'val2'})

        commonSum(q, val1, val2)
    }
})


export default level

